import React from "react";
import { useCompanyTimezone } from "hooks/useTimezone";
import { getComponentRefTime, toZonedDateTime } from "utils/time-utils";
import { CurrentDateDisplayProps } from "./CurentDateDisplayTypes";
import { getTextColor } from "../charts/utils";
import getCurrentDate from "./CurrentDateDisplayUtils";
import "./CurrentDateDisplay.scss";

export default function CurrentDateDisplay(props: CurrentDateDisplayProps) {
  const companyTz = useCompanyTimezone();
  const referenceTime = getComponentRefTime(props);

  return (
    <div className="current-date-display-component" style={{ color: getTextColor(props.theme) }}>
      {getCurrentDate(
        companyTz,
        props.displayWeekOfYear,
        props.showFinishedWeek,
        props.year,
        props.month,
        props.day,
        toZonedDateTime(referenceTime, companyTz)
      )}
    </div>
  );
}
